'use client'
import { cn } from '~/lib/utils'
import React from 'react'
// import Mermaid from './Mermaid'

interface CodeProps extends React.HTMLProps<HTMLElement> {
    'data-language'?: string
}

const Code = (props: CodeProps) => {
    // const [mermaid, setMermaid] = React.useState('')
    // const ref = React.useRef<HTMLDivElement>(null)
    // const math = props['data-language'] === 'mmd'
    // useEffect(() => {
    //     if (math && ref.current) setMermaid(ref.current.innerText)
    // }, [math, ref])
    return (
        <>
            {/* {!math && !mermaid && (
                <code
                    ref={ref}
                    {...props}
                    className={cn(props.className, 'scrollbar overflow-x-auto py-3 text-sm lg:text-base')}
                >
                    {props.children}
                </code>
            )}
            {math && (
                <div ref={ref} className='hidden'>
                    {props.children}
                </div>
            )}
            {math && mermaid && <Mermaid data={mermaid} />} */}
            {/* Not mermaid */}
            <code
                {...props}
                className={cn(props.className, 'scrollbar overflow-x-auto py-3 text-sm lg:text-base')}
            >
                {props.children}
            </code>
        </>
    )
}

export default Code
